import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UsersService } from './users.service';
import { User } from './user.model';
import { AuthService } from '../../auth/auth.service';


@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, FormsModule]
})
export class UsersComponent implements OnInit {
    users: User[] = [];
    loading = false;
    // pagination
    totalItems = 0;
    searchTerm = '';


    constructor(
        private usersService: UsersService,
        private router: Router,
        private authService: AuthService
    ) { }


    ngOnInit(): void {
        this.loadUsers();
    }

    loadUsers(): void {
        this.loading = true;
        // Fetch users without strict pagination (defaulting to a high limit if necessary)
        this.usersService.getUsers(1, 1000, this.searchTerm).subscribe({
            next: (res: any) => {
                this.users = res?.users || [];
                this.totalItems = res?.total || 0;
                this.loading = false;
            },

            error: err => {
                console.error('Failed to load users', err);
                this.loading = false;
            }
        });
    }

    onSearch(): void {
        this.loadUsers();
    }


    getRoleNames(user: User): string {
        if (!user.roles || user.roles.length === 0) {
            return 'N/A';
        }

        return user.roles
            .map((r: any) => r.role?.name || 'Unknown')
            .filter((name: string) => name !== 'Unknown')
            .join(', ') || 'N/A';
    }

    deleteUser(id: string): void {
        if (confirm('Are you sure you want to delete this user?')) {
            this.usersService.deleteUser(id).subscribe({
                next: () => this.loadUsers(),
                error: err => console.error('Delete failed', err)
            });
        }
    }

    isAdmin(): boolean {
        return this.authService.isAdmin();
    }

    toggleStatus(user: User): void {
        const newStatus = !user.isActive;
        this.usersService.updateUser(user.id!, { isActive: newStatus }).subscribe({
            next: () => {
                user.isActive = newStatus;
            },
            error: (err) => {
                console.error('Failed to toggle status', err);
                // Optionally revert UI if needed, though loadUsers usually handles it
            }
        });
    }


    // navigation to create/edit page (could be modal, simplified as route)
    editUser(id?: string): void {
        if (id) {
            this.router.navigate(['/users/edit', id]);
        } else {
            this.router.navigate(['/users/create']);
        }
    }
}
